import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { INFLUENTIAL_ARTICLES } from "@/lib/mediaCoverage";

const INITIAL = 6;

const ArticleCard = ({ a }) => (
  <a
    href={a.url}
    target="_blank"
    rel="noopener noreferrer"
    className="surface overflow-hidden flex flex-col group hover:border-[color:var(--gold)]/40 transition-colors"
    data-testid={`article-preview-${a.id}`}
  >
    <div className="aspect-[16/9] overflow-hidden bg-white/[0.03]">
      <img
        src={a.image}
        alt={a.title}
        loading="lazy"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
      />
    </div>
    <div className="p-6 flex flex-col gap-3 flex-1">
      <p className="text-[10px] uppercase tracking-[0.2em] text-[color:var(--gold)]">{a.topic}</p>
      <h3 className="font-serif text-xl leading-snug tracking-tight group-hover:text-[color:var(--gold)] transition-colors">
        {a.title}
      </h3>
      <p className="text-sm text-white/55 leading-relaxed line-clamp-2">{a.dek}</p>
      <div className="mt-auto pt-2 flex items-center justify-between text-[11px] uppercase tracking-[0.18em] text-white/40">
        <span>{a.date} · {a.readTime} read</span>
        <ArrowUpRight size={14} className="group-hover:text-[color:var(--gold)] transition-colors" />
      </div>
    </div>
  </a>
);

export const ArticlePreviews = () => {
  const [showAll, setShowAll] = useState(false);
  const list = showAll ? INFLUENTIAL_ARTICLES : INFLUENTIAL_ARTICLES.slice(0, INITIAL);
  return (
    <div className="mt-10" data-testid="article-previews">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {list.map((a) => <ArticleCard key={a.id} a={a} />)}
      </div>
      {INFLUENTIAL_ARTICLES.length > INITIAL && (
        <button
          type="button"
          onClick={() => setShowAll((v) => !v)}
          className="btn-ghost-gold mt-8 inline-flex items-center gap-2 px-7 py-3 text-xs"
          data-testid="article-previews-toggle"
        >
          {showAll ? "Show fewer" : `Show all ${INFLUENTIAL_ARTICLES.length} articles`}
        </button>
      )}
    </div>
  );
};
